module.exports = __webpack_public_path__ + "img/spritz-serving3.d0715c67.svg";